import * as React from "react";
import { Button } from "@fluentui/react-components";
import { Add24Regular, Subtract24Regular } from "@fluentui/react-icons";
import { makeStyles } from "@fluentui/react-components";
import { SectionHeaderControl } from "./SectionHeaderControl.js";

const useStyles = makeStyles({
  card: {
    border: "1px solid var(--colorNeutralStroke2)",
    borderRadius: "8px",
    padding: "12px",
    display: "grid",
    gap: "8px",
  },
});

export interface EntityNodeControlProps {
  title: React.ReactNode;
  titleLeading?: React.ReactNode;
  titleActions?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

export function EntityNodeControl({
  title,
  titleLeading,
  titleActions,
  subtitle,
  actions,
  children,
  collapsible = false,
  defaultExpanded = true,
}: EntityNodeControlProps): JSX.Element {
  const styles = useStyles();
  const [isExpanded, setIsExpanded] = React.useState(defaultExpanded);

  const headerActions = (
    <>
      {collapsible ? (
        <Button
          appearance="subtle"
          icon={isExpanded ? <Subtract24Regular /> : <Add24Regular />}
          aria-label={isExpanded ? "Collapse" : "Expand"}
          title={isExpanded ? "Collapse" : "Expand"}
          onClick={() => setIsExpanded((value) => !value)}
        />
      ) : null}
      {actions}
    </>
  );

  return (
    <div className={styles.card}>
      <SectionHeaderControl
        title={title}
        titleLeading={titleLeading}
        titleActions={titleActions}
        subtitle={subtitle}
        actions={headerActions}
      />
      {isExpanded ? children : null}
    </div>
  );
}